import Conexion_api from "@/api/Conexion_api.js";

const obtener_configuracion_contrasena = function(distribuidor){
    return new Promise((resuelve,rechaza) => {
    Conexion_api({
        body: {
            base: distribuidor.base,
            base_config: distribuidor.base,          
            configuraciones:["activar_contrasenia"]
        },
        evento: "pedidos_configuraciones/obtener_configuraciones"
    }).then(respuesta => {
        if(respuesta.data.error){
            this.mostrar_loader = false;
            this.$root.$emit("snackbar", { mostrar: true, color: "error", texto: respuesta.data.error });
            return rechaza(respuesta.data.error);
        }
        
        if (respuesta.data.datos.configuraciones_pedidos && respuesta.data.datos.configuraciones_pedidos.length !== 0) {
            distribuidor.contrasenia = respuesta.data.datos.configuraciones_pedidos[0].valor
        }else distribuidor.contrasenia = false
        return resuelve(true);
    }).catch(err => {
        err = String(err);
        console.error(err);
        this.mostrar_loader = false;
        this.$root.$emit("snackbar", { mostrar: true, color: "error", texto: err });
        return rechaza(err);
    })  
    })
}
export default obtener_configuracion_contrasena